// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keyboard-key ion-button {
  margin: 0;
  height: 35px;
  font-size: 18px;
  --padding-start: 0;
  --padding-end: 0;
}
.keyboard-key ion-button ion-icon {
  font-size: 26px;
}

.actions ion-button {
  font-size: 17px;
}

.agent-inputs .active {
  border: 1px solid #1a1a1a;
}
.agent-inputs ion-item {
  padding: 0 5px;
}

.flexwrap {
  flex-wrap: wrap;
}

.flexnowrap {
  flex-wrap: nowrap;
  margin: 3px;
}

.flexnowrap ion-label {
  white-space: nowrap;
}

.fontbyscreen ion-badge {
  font-size: 1.1rem;
}

@media screen and (max-width: 700px) {
  .fontbyscreen ion-badge {
    font-size: 0.8rem;
  }
}
.close-btn {
  --border-radius: 10px 10px 0 0;
  --box-shadow: 0;
  margin: 4px 20px;
  width: 200px;
  height: 40px;
}
.close-btn .cart-box {
  direction: ltr;
  gap: 13px;
}
.close-btn .cart-box ion-badge {
  display: flex;
  --background: var(--button-a-background);
  --color: var(--button-a-text);
}
.close-btn ::ng-deep app-loading ion-spinner {
  width: 20px !important;
}

.footer-item-title {
  margin: 7px 0px;
}
.footer-item-title ion-chip {
  margin: 0;
  --background: var(--ion-color-success);
  --color: #fff;
}
.footer-item-title ion-chip.close-chip {
  padding: 5px;
  margin: 0 3px;
  height: auto;
  --background: #f44336;
}
.footer-item-title ion-chip.close-chip ion-icon {
  margin: 0;
  font-size: 12px;
  color: #fff;
}

cart-fab ion-fab {
  bottom: 145px !important;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/components/agent-item-toolbar/agent-item-toolbar.component.scss"],"names":[],"mappings":"AAGE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EAEA,kBAAA;EACA,gBAAA;AAHJ;AAKI;EACE,eAAA;AAHN;;AASE;EACE,eAAA;AANJ;;AAWE;EACE,yBAAA;AARJ;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,eAAA;AAVF;;AAaA;EACE,iBAAA;EACA,WAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaA;EACE;IACE,iBAAA;EAVF;AACF;AAaA;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAXF;AAaE;EACE,cAAA;EACA,SAAA;AAXJ;AAaI;EACE,aAAA;EACA,wCAAA;EACA,6BAAA;AAXN;AAgBM;EACE,sBAAA;AAdR;;AAqBA;EACE,eAAA;AAlBF;AAoBE;EACE,SAAA;EACA,sCAAA;EACA,aAAA;AAlBJ;AAqBE;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;AAnBJ;AAqBI;EACE,SAAA;EACA,eAAA;EACA,WAAA;AAnBN;;AAoCI;EACE,wBAAA;AAjCN","sourcesContent":[".keyboard-key {\n  //padding: 1px;\n\n  ion-button {\n    margin: 0;\n    height: 35px;\n    font-size: 18px;\n\n    --padding-start: 0;\n    --padding-end: 0;\n\n    ion-icon {\n      font-size: 26px;\n    }\n  }\n}\n\n.actions {\n  ion-button {\n    font-size: 17px;\n  }\n}\n\n.agent-inputs {\n  .active {\n    border: 1px solid #1a1a1a;\n  }\n\n  ion-item {\n    padding: 0 5px;\n  }\n}\n\n.flexwrap {\n  flex-wrap: wrap;\n}\n\n.flexnowrap {\n  flex-wrap: nowrap;\n  margin: 3px;\n}\n\n.flexnowrap ion-label {\n  white-space: nowrap;\n}\n\n.fontbyscreen ion-badge {\n  font-size: 1.1rem;\n}\n\n@media screen and (max-width: 700px) {\n  .fontbyscreen ion-badge {\n    font-size: 0.8rem;\n  }\n}\n\n.close-btn{\n  --border-radius: 10px 10px 0 0;\n  --box-shadow: 0;\n  margin: 4px 20px;\n  width: 200px;\n  height: 40px;\n\n  .cart-box{\n    direction: ltr;\n    gap: 13px;\n\n    ion-badge{\n      display: flex;\n      --background: var(--button-a-background);\n      --color: var(--button-a-text);\n    }\n  }\n  ::ng-deep{\n    app-loading{\n      ion-spinner {\n        width: 20px !important;\n      }\n    }\n  }\n\n}\n\n.footer-item-title{\n  margin: 7px 0px;\n\n  ion-chip{\n    margin: 0;\n    --background: var(--ion-color-success);\n    --color: #fff;\n  }\n\n  ion-chip.close-chip{\n    padding: 5px;\n    margin: 0 3px;\n    height: auto;\n    --background: #f44336;\n\n    ion-icon {\n      margin: 0;\n      font-size: 12px;\n      color: #fff;\n    }\n  }\n  //\n  //span {\n  //  background: #fff;\n  //  padding: 5px;\n  //  box-shadow: 0px -5px 17px 2px #d1d1d1;\n  //  /* border: 1px solid #d1d1d1; */\n  //  border-top-left-radius: 5px;\n  //  border-top-right-radius: 5px;\n  //  font-size: 14px;\n  //}\n}\n\n//::ng-deep{\n  cart-fab{\n    ion-fab{\n      bottom: 145px !important;\n    }\n  }\n//}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
